var _path, _circle, _path2, _circle2, _path3, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuLessons = function SvgMenuLessons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3m3 5c-4.6 0-6 3.3-6 3.3V19h12v-1.7S16.6 14 12 14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 8.5,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13c-1.2 0-2.1.3-2.8.8 2.3 1.1 3.2 3 3.2 3.2v.1H23v-1.3c0-.1-1.1-2.8-4.5-2.8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 8.5,
    r: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13c-1.2 0-2.1.3-2.8.8 2.3 1.1 3.2 3 3.2 3.2v.1H23v-1.3c0-.1-1.1-2.8-4.5-2.8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 8.5,
    r: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13c1.2 0 2.1.3 2.8.8-2.3 1.1-3.2 3-3.2 3.2v.1H1v-1.3c0-.1 1.1-2.8 4.5-2.8"
  })));
};
export { SvgMenuLessons as ReactComponent };